module.exports = __webpack_public_path__ + "static/media/recursos-materiais-02.f356e34e.png";